import { render, staticRenderFns } from "./MyCalendar.vue?vue&type=template&id=4ff735e5"
import script from "./MyCalendar.vue?vue&type=script&lang=js"
export * from "./MyCalendar.vue?vue&type=script&lang=js"
import style0 from "./MyCalendar.vue?vue&type=style&index=0&id=4ff735e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports